<template>
  <div>
    <vs-popup class="sales-quote-email-log-popup" id="popup" :title='`FG STOCK ACTIVITY LOGS`' :active.sync="open"
      :buttons-hidden="true">
      <vx-card no-shadow>
        <vs-table class="my-8" hoverFlat id="quote_item_table" :data="logs" stripe>
          <template slot="thead">
            <vs-th width="25%">DATE/TIME</vs-th>
            <vs-th width="25%">EVENT TYPE</vs-th>
            <vs-th width="50%">DONE BY</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr_item, indextr) in data">

              <vs-td>
                {{ __dateTimeFormatter(tr_item.created_at) }}
              </vs-td>
              <vs-td>
                {{ tr_item.description }}
              </vs-td>
              <vs-td>
                {{ tr_item.causer.name }}
              </vs-td>
              <template class="expand-user" slot="expand">
                <div class="con-expand-users w-4/5">
                  <span v-if="tr_item.properties.old">
                    <div class="vx-row">
                      <div class="vx-col w-full p-16">
                        <vs-table noDataText="" class="w-full">
                          <template slot="thead">
                            <vs-th>CHANGED FIELD</vs-th>
                            <vs-th>PREVIOUS VALUE</vs-th>
                            <vs-th>NEW VALUE</vs-th>
                          </template>
                          <template>
                            <vs-tr :key="name" v-for="(item, name) in tr_item.properties.old">
                              <vs-td>{{ underScoreRemove(name) }}</vs-td>
                              <vs-td>{{ tr_item.properties.old[name] }}</vs-td>
                              <vs-td>{{ tr_item.properties.attributes[name] }}</vs-td>
                            </vs-tr>
                          </template>
                        </vs-table>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    <div class="vx-row">
                      <div class="vx-col w-full p-16">
                        <vs-table noDataText="" class="w-full">
                          <template slot="thead">
                            <vs-th>CHANGED FIELD</vs-th>
                            <vs-th>VALUE</vs-th>
                          </template>
                          <template>
                            <vs-tr :key="name" v-for="(item, name) in tr_item.properties.attributes">
                              <vs-td>{{ underScoreRemove(name) }}</vs-td>
                              <vs-td>{{ tr_item.properties.attributes[name] }}</vs-td>
                            </vs-tr>
                          </template>
                        </vs-table>
                      </div>
                    </div>
                  </span>
                </div>
              </template>
            </vs-tr>
          </template>
        </vs-table>

      </vx-card>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: "FormulationStockLogPopUp",
  data() {
    return {
      logs: [],
      open: false,
    }
  },
  methods: {
    async openPopup(logs) {
      this.logs = logs
      this.open = true
    },
    underScoreRemove(string) {
      return string.replaceAll("_", " ");
    }
  }
}
</script>

<style scoped>
.sales-quote-email-log-popup>>>.vs-popup {
  min-width: 50% !important;
}
</style>
